"use strict";
/* tslint:disable:max-classes-per-file */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalTrackFactoryWithConstraints = exports.ErrorDeviceNotFound = exports.ErrorOverconstrained = exports.ErrorCanceled = exports.ErrorDeviceBusy = exports.Error = exports.ScreenShareAudioTrack = exports.Track = exports.TrackType = void 0;
var TrackType;
(function (TrackType) {
    TrackType["AUDIO"] = "audio";
    TrackType["VIDEO"] = "video";
    TrackType["SCREEN"] = "screen";
    TrackType["SCREENAUDIO"] = "screenaudio";
})(TrackType = exports.TrackType || (exports.TrackType = {}));
class Track {
    constructor(type, track, mid, constrains) {
        this.stopped = false;
        this.type = type;
        this.track = track;
        this.mid = mid;
        this.constrains = constrains;
    }
    stop() {
        this.stopped = true;
        this.track.stop();
    }
    isActive() {
        if (this.stopped) {
            return false;
        }
        return this.track.enabled;
    }
}
exports.Track = Track;
class ScreenShareAudioTrack extends Track {
    constructor(type, track, mid, constrains) {
        super(type, track, mid, constrains);
        this.originalTrack = track;
        this.ctx = new AudioContext();
        this.src = this.ctx.createMediaStreamSource(new MediaStream([track]));
        this.dst = this.ctx.createMediaStreamDestination();
        this.gainNode = this.ctx.createGain();
        this.gainNode.gain.value = 1;
        this.src.connect(this.gainNode);
        this.gainNode.connect(this.dst);
        this.track = this.dst.stream.getAudioTracks()[0];
    }
    set volume(volume) {
        if (volume < 0) {
            volume = 0;
        }
        else if (volume > 100) {
            volume = 100;
        }
        this.gainNode.gain.value = volume / 100.0;
    }
    get volume() {
        return Math.round(this.gainNode.gain.value * 100);
    }
    stop() {
        this.src.disconnect();
        this.dst.disconnect();
        this.originalTrack.stop();
        super.stop();
    }
}
exports.ScreenShareAudioTrack = ScreenShareAudioTrack;
class Error {
    constructor(type, error) {
        this.type = type;
        this.error = error;
    }
}
exports.Error = Error;
class ErrorDeviceBusy extends Error {
}
exports.ErrorDeviceBusy = ErrorDeviceBusy;
class ErrorCanceled extends Error {
}
exports.ErrorCanceled = ErrorCanceled;
class ErrorOverconstrained extends Error {
}
exports.ErrorOverconstrained = ErrorOverconstrained;
class ErrorDeviceNotFound extends Error {
}
exports.ErrorDeviceNotFound = ErrorDeviceNotFound;
class LocalTrackFactoryWithConstraints {
    constructor(constraints) {
        this.constraints = constraints;
        this.tracks = new Map();
    }
    createTracks(types) {
        return __awaiter(this, void 0, void 0, function* () {
            const userConstraints = {
                video: false,
                audio: false,
            };
            const screenConstraints = {
                video: false,
                audio: false,
            };
            const tracks = [];
            const request = [];
            if (types.includes(TrackType.AUDIO)) {
                const c = this.constraints.get(TrackType.AUDIO);
                const oldTrack = this.tracks.get(TrackType.AUDIO);
                if (oldTrack && !(oldTrack === null || oldTrack === void 0 ? void 0 : oldTrack.stopped) && oldTrack.constrains === c) {
                    tracks.push(this.tracks.get(TrackType.AUDIO));
                }
                else if (c) {
                    userConstraints.audio = c;
                    request.push(TrackType.AUDIO);
                }
            }
            if (types.includes(TrackType.VIDEO)) {
                const oldTrack = this.tracks.get(TrackType.VIDEO);
                const c = this.constraints.get(TrackType.VIDEO);
                if (oldTrack && !(oldTrack === null || oldTrack === void 0 ? void 0 : oldTrack.stopped) && oldTrack.constrains === c) {
                    tracks.push(this.tracks.get(TrackType.VIDEO));
                }
                else if (c) {
                    userConstraints.video = c;
                    request.push(TrackType.VIDEO);
                }
            }
            if (types.includes(TrackType.SCREEN)) {
                const c = this.constraints.get(TrackType.SCREEN);
                const oldTrack = this.tracks.get(TrackType.SCREEN);
                if (oldTrack && !(oldTrack === null || oldTrack === void 0 ? void 0 : oldTrack.stopped) && oldTrack.constrains === c) {
                    tracks.push(this.tracks.get(TrackType.SCREEN));
                }
                else if (c) {
                    screenConstraints.video = c;
                    if (this.constraints.get(TrackType.SCREENAUDIO)) {
                        screenConstraints.audio = true;
                    }
                    request.push(TrackType.SCREEN);
                }
            }
            try {
                if (request.includes(TrackType.AUDIO) || request.includes(TrackType.VIDEO)) {
                    try {
                        const stream = yield navigator.mediaDevices.getUserMedia(userConstraints);
                        stream.getTracks().forEach((t) => {
                            const type = t.kind === TrackType.AUDIO ? TrackType.AUDIO : TrackType.VIDEO;
                            const c = t.kind === TrackType.AUDIO ? userConstraints.audio : userConstraints.video;
                            tracks.push(new Track(type, t, undefined, c));
                        });
                    }
                    catch (error) {
                        if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
                            throw new ErrorDeviceNotFound(TrackType.AUDIO, error);
                        }
                        else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
                            throw new ErrorDeviceBusy(TrackType.AUDIO, error);
                        }
                        else if (error.name === 'NotAllowedError') {
                            throw new ErrorCanceled(TrackType.AUDIO, error);
                        }
                        else if (error.name === 'PermissionDismissedError') {
                            throw new ErrorCanceled(TrackType.AUDIO, error);
                        }
                        else if (error.name === 'OverconstrainedError') {
                            throw new ErrorOverconstrained(TrackType.VIDEO, error);
                        }
                        else {
                            throw error;
                        }
                    }
                }
                if (request.includes(TrackType.SCREEN)) {
                    try {
                        // @ts-ignore
                        const stream = yield navigator.mediaDevices.getDisplayMedia(screenConstraints);
                        // @ts-ignore
                        stream.getTracks().forEach((t) => {
                            const type = t.kind === TrackType.AUDIO ? TrackType.SCREENAUDIO : TrackType.SCREEN;
                            const c = t.kind === TrackType.AUDIO ? screenConstraints.audio : screenConstraints.video;
                            if (type === TrackType.SCREENAUDIO) {
                                tracks.push(new ScreenShareAudioTrack(type, t, undefined, c));
                            }
                            else {
                                tracks.push(new Track(type, t, undefined, c));
                            }
                        });
                    }
                    catch (error) {
                        if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
                            throw new ErrorDeviceNotFound(TrackType.SCREEN, error);
                        }
                        else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
                            throw new ErrorDeviceBusy(TrackType.SCREEN, error);
                        }
                        else if (error.name === 'NotAllowedError') {
                            throw new ErrorCanceled(TrackType.SCREEN, error);
                        }
                        else if (error.name === 'PermissionDismissedError') {
                            throw new ErrorCanceled(TrackType.SCREEN, error);
                        }
                        else if (error.name === 'OverconstrainedError') {
                            throw new ErrorOverconstrained(TrackType.SCREEN, error);
                        }
                        else {
                            throw error;
                        }
                    }
                }
                tracks.forEach((t) => this.tracks.set(t.type, t));
            }
            catch (error) {
                tracks.forEach((t) => t.track.stop());
                throw error;
            }
            return tracks;
        });
    }
    ;
    destroy() {
        this.tracks.forEach((track) => {
            track.stop();
        });
    }
    ;
}
exports.LocalTrackFactoryWithConstraints = LocalTrackFactoryWithConstraints;
//# sourceMappingURL=Tracks.js.map